module.exports = __webpack_public_path__ + "static/media/davide-berruto-loop-1.4cf0daa4.mp4";